import { haptic } from '@/lib/telegram';
import clsx from 'clsx';
import styles from './Select.module.css';

interface Option<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  value: T;
  onChange: (v: T) => void;
  options: Option<T>[];
}

export function Select<T extends string>({ value, onChange, options }: Props<T>) {
  return (
    <div className={styles.grid}>
      {options.map((opt) => {
        const isActive = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => { haptic.selection(); onChange(opt.value); }}
            className={clsx(styles.btn, isActive && styles.btnActive)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}